import db from "../db/db";
import { v4 as uuidv4 } from "uuid";
import API from "./API";
import { fr } from "date-fns/locale";

export const SyncUtils = {
  createSyncMeta,
  getProductData,
  searchInCache,
  searchInCache2,
  searchInCacheWithBarcode,
  getProductBean,
  getProductBean2,
  requestSync,
  getSearchCacheData,
  getCacheData,
  getSearchCacheDataForUnitType,
  listSerchInCache,
  getHashMapFromDb,
};

const syncQueue = [];

function requestSync() {}

async function getHashMapFromDb(table) {
  let map = {};
  let dbData = await db[table].toArray();
  for (let d of dbData) {
    map[d.id] = d.hash;
  }
  return map;
}

function createSyncMeta(operationType, tableIdentifier, tableName) {
  if (
    operationType == "CREATE" ||
    operationType == "UPDATE" ||
    operationType == "DELETE"
  ) {
    let saveObject = Object.create(null);
    saveObject["id"] = new Date().getTime();
    saveObject["operationType"] = operationType;
    saveObject["tableIdentifier"] = tableIdentifier;
    saveObject["tableName"] = tableName;
    saveObject["eventOn"] = new Date();
    db.table("sync_meta").put(saveObject);
  } else {
    console.log("*******OPERTAION TYPE NOT ALLOWED*****");
  }
}

async function getProductData() {
  let t1 = new Date();
  let dbData = await db.product.toArray();
  //console.log("POrod Lookup took", new Date() - t1);

  let searchCache = [];
  let prodCache = [];
  let hashMap = {};
  for (let i = 0; i < dbData.length; i++) {
    let d = getCacheData(dbData[i]);
    prodCache.push(d);
    hashMap[d.id] = d.hash;
    getSearchCacheData(dbData[i], searchCache);
  }
  console.log("Cache Build Lookup took", new Date() - t1);
  return [searchCache, prodCache, hashMap];
}

function getSearchCacheDataForUnitType(d, unitType) {
  let arr = [];
  getSearchCacheData(d, arr);
  for (let a of arr) {
    if (a.unitType == unitType) {
      return a;
    }
  }
  return null;
}

function getSearchCacheData(d, cache) {
  for (let j = 0; j < d.productPricingBeanList.length; j++) {
    let val = {
      id: d.id,
      name: d.name,
      nameUpper: d.name.toUpperCase(),
      code: d.code,
      isFastItem: d.isFastItem,
      price: d.productPricingBeanList[j].price,
      unitType: d.productPricingBeanList[j].unitType,
      factor: d.productPricingBeanList[j].factor,
      barcodes: d.productPricingBeanList[j].productBarcodeBeanList,
      productType: getProductType(d),
      isForPos: d.isForPos,
    };
    cache.push(val);
  }
}

function getCacheData(d) {
  let barcode = "";
  let arr = [];
  if (
    d.productPricingBeanList[0] &&
    d.productPricingBeanList[0].productBarcodeBeanList[0] &&
    d.productPricingBeanList[0].productBarcodeBeanList[0].barcode
  ) {
    barcode = d.productPricingBeanList[0].productBarcodeBeanList[0].barcode;
  }

  let upperName = d.name ? d.name.toUpperCase() : "";
  let vendorName = d.vendorBean ? d.vendorBean.name : null;
  let deptName = d.deptBean ? d.deptBean.name : null;

  return {
    productType: getProductType(d),
    id: d.id,
    nameUpper: upperName,
    name: d.name,
    code: d.code,
    deptName: deptName,
    vendorName: vendorName,
    price: d.productPricingBeanList[0].price,
    barcode: barcode,
    pricing: d.productPricingBeanList,
    hash: d.hash,
    isForPos: d.isForPos,
  };
}

function getProductType(d) {
  if (d.productType) {
    return d.productType;
  }
  if (d.isRestaurantItem) {
    return "R";
  }
  if (d.isService) {
    return "S";
  }
  return "I";
}

async function searchInCacheWithBarcode(cache, searchTxt) {
  for (let prd of cache) {
    let found = false;
    for (let barcode of prd.barcodes) {
      if (searchTxt == barcode.barcode) {
        found = true;
      }
    }
    if (found) {
      let obj = { ...prd };
      let [prodBean, pricingBean] = await getProductBean(obj);
      obj["productBean"] = prodBean;
      return obj;
    }
  }
  return null;
}

async function searchInCache(
  cache,
  searchTxt,
  limit,
  validProductTypes,
  posFlag,
  includeStock,
  factor
) {
  let count = 0;
  let res = [];
  for (let prd of cache) {
    if (factor) {
      if (parseInt(prd.factor) != factor) {
        continue;
      }
    }
    let found = false;
    for (let barcode of prd.barcodes) {
      if (searchTxt == barcode.barcode) {
        found = true;
      }
    }
    if (!found) {
      if (searchTxt === prd.code) {
        found = true;
      }
    }
    if (!found) {
      if (prd.name.toLowerCase().includes(searchTxt.toLowerCase())) {
        found = true;
      }
    }
    if (found) {
      if (validProductTypes) {
        if (!prd.productType.includes(validProductTypes)) {
          found = false;
        }
      }
      if (posFlag) {
        if (prd.isForPos) {
          found = true;
        }
      }
    }
    if (found) {
      let obj = { ...prd };
      obj["selectdd"] = false;
      res.push(obj);
      count = count + 1;
    }
    if (count >= limit) {
      break;
    }
  }
  return res;
}

function searchInCache2(cache, searchTxt, limit, validProductTypes, posFlag) {
  let count = 0;
  let res = [];
  for (let prd of cache) {
    let found = false;

    for (let pr of prd.pricing) {
      for (let b of pr.productBarcodeBeanList) {
        if (searchTxt == b.barcode) {
          found = true;
        }
      }
      /**/
    }
    if (!found) {
      if (searchTxt === prd.code) {
        found = true;
      }
    }
    if (!found) {
      if (prd.name.toLowerCase().includes(searchTxt.toLowerCase())) {
        found = true;
      }
    }

    if (found) {
      if (validProductTypes) {
        if (!prd.productType.includes(validProductTypes)) {
          found = false;
        }
      }
      if (posFlag) {
        if (prd.isForPos) {
          found = true;
        }
      }
    }

    if (found) {
      let obj = { ...prd };
      obj["selectdd"] = false;
      res.push(obj);
      count = count + 1;
    }
    if (count >= limit) {
      break;
    }
  }
  return res;
}

function listSerchInCache(cache, excludeList, filter, sort, limitArr) {
  let t1 = new Date();
  let stage1 = [];
  let andFilters = [];
  let orFilters = [];
  for (let f of filter) {
    if (f.conditionType == "and") {
      andFilters.push(f);
    } else {
      orFilters.push(f);
    }
  }
  for (let c of cache) {
    let found = false;
    if (andFilters.length == 0) {
      found = true;
    } else {
      for (let a of andFilters) {
        if (a.fieldValueType == "boolean") {
          if (c[a.id] == (a.value == "true" ? true : false)) {
            found = true;
          } else {
            found = false;
          }
        } else if (a.fieldValueType == "string") {
          if (c[a.id] == a.value) {
            found = true;
          } else {
            found = false;
          }
        }
      }
    }
    if (found) {
      let orFound = false;
      if (orFilters.length == 0) {
        orFound = true;
      } else {
        for (let a of orFilters) {
          if (a.fieldValueType == "boolean") {
          } else if (a.fieldValueType == "string") {
            if (a.matchType == "BROAD_MATCH") {
              if (c[a.id].toLowerCase().includes(a.value.toLowerCase())) {
                orFound = true;
                break;
              }
            }
          }
        }
      }
      if (orFound) {
        stage1.push(c);
      }
    }
  }

  if (sort.length > 0) {
    Array.prototype.alphaSort = function (sortParameter) {
      function compare(a, b) {
        let v1 = a[sortParameter.id];
        let v2 = b[sortParameter.id];
        if ("ASC" === sortParameter.sortOrder) {
          return v1.localeCompare(v2);
        } else {
          return v2.localeCompare(v1);
        }
      }
      this.sort(compare);
    };
    stage1.alphaSort(sort[0]);
  }
  let sliced = stage1.slice(limitArr[0], limitArr[1]);

  let startIndex = limitArr[0];
  let endIndex = limitArr[1];
  let limit = endIndex - startIndex + 1;
  let pageNumber = endIndex / limit;
  let res = {
    data: {
      contentRange:
        Math.trunc(pageNumber) +
        "/" +
        Math.trunc(pageNumber + limit) +
        "/" +
        stage1.length,
      data: sliced,
      totalCount: stage1.length,
    },
  };

  let t2 = new Date();

  return res;
}

async function getProductBean(cacheData) {
  let prodBean = await db.product.get(cacheData.id);
  let pricingBean = null;
  if (prodBean) {
    for (let pricing of prodBean.productPricingBeanList) {
      if (pricing.unitType === cacheData.unitType) {
        pricingBean = pricing;
      }
    }
  }
  return [prodBean, pricingBean];
}

async function getProductBean2(cacheData) {
  let prodBean = await db.product.get(cacheData.id);
  return [prodBean];
}
